import { Pipe, PipeTransform } from '@angular/core';
import { EnumModel } from '@shared/models/enum-model';
import { enumToArray } from '@shared/utils/enum-to-array.util';

@Pipe({
  name: 'enumToArray'
})
export class EnumToArrayPipe implements PipeTransform {

  transform(value: object, customDisplayNames?: { [key: string]: string }): EnumModel[] {
    return enumToArray(value, customDisplayNames);
  }

}